<template>
  <div>
    <br />
    <h5 class="pageTitle">Inscription</h5>
    <p>
      Vous devez ici inscrire les informations demandées. Vous pourrez choisir
      votre type d'adhésion au Club après avoir rempli la présente section.
    </p>

    <div class="section">
      <h3>Territoire du COQ</h3>
      <img
          :src="require('../../assets/images/territoire.jpg')"
          class="img-responsive"
          style="width: 100%; padding-bottom: 20px"
      />
      <p>
        Assurez-vous que votre région fait partie du <a href="https://coq.qc.ca/documents/territoire_coq_2012.jpg">territoire
        couvert par le COQ</a>.
        Si ce n'est pas le cas, vous pouvez consulter le <a href="https://www.quebecoiseaux.org/fr/clubs">site Web de
        QuébecOiseaux</a> pour connaître les autres clubs.
      </p>
      <p>
        Toutefois, si vous le souhaitez, vous pouvez tout de même adhérer au COQ. Sachez cependant que les activités
        offertes par ce club se dérouleront hors de votre région.
      </p>
    </div>
    <br />

    <register-user :user="user" ref="user"/>
    <register-member :member="member" ref="member"/>

    <b-button @click="register" style="width: 100%" variant="primary">
      <template v-if="loading">
        <font-awesome-icon icon="spinner" spin/>
      </template>
      <template v-else>
        Créer mon compte COQ
      </template>
    </b-button>

    <br/>
    <br/>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';
  import RegisterMember from '../../components/Inscription/Inscription_Membre';
  import RegisterUser from '../../components/Inscription/Inscription_Utilisateur';

  export default {
    name: 'new-member-registration-v2',
    data() {
      return {
        loading: false,
        user: {
          email: '',
          password: '',
          phone: '',
          mobilePhone: '',
          address: {
            city: 'Québec',
            province: 'Québec',
            country: 'Canada',
            // eslint-disable-next-line camelcase
            postal_code: ''
          },
          isFrom: '',
          isFromOther: null
        },
        member: {
          firstName: '',
          lastName: '',
          birthday: null,
          phone: '',
          mobilePhone: '',
          liveInQuebecCity: true,
          commitees: [],
          newsletter: true
        }
      };
    },
    components: {
      RegisterUser,
      RegisterMember
    },
    computed: {},
    methods: {
      ...mapActions('account', {
        _register: 'register',
        _login: 'login'
      }),
      async register() {
        // Check forms
        if (!(this.$refs.user.check() && this.$refs.member.check())) {
          return;
        }

        if (!this.loading) {
          this.loading = true;

          try {
            // Fix the birthday to the wanted format for the API
            this.member.birthday = this.member.birthday.substring(0, 10);

            // Create the new user
            await this._register({ user: this.user, member: this.member });

            // Success
            await this.$swal.fire({
              title: 'Succès',
              text: 'Votre compte COQ a été créé avec succès! Vous serez connecté automatiquement dans quelques secondes.',
              type: 'success',
              timer: 10 * 1000
            });

            // Auto-login
            await this._login({
              email: this.user.email,
              password: this.user.password
            });

            // Move to the member page
            await this.$router.push({ name: 'MembersPage' });
          }
          catch (e) {
            // Handle the email already used error
            if (e && Array.isArray(e) && e[0].messages[0].id === 'Auth.form.error.email.taken') {
              this.$swal.fire({
                title: 'Erreur',
                text: "L'adresse courriel a déjà été utilisé par un autre membre. Veuillez contacter l'administration du COQ pour régler la situation.",
                type: 'error'
              });
            }
            else {
              this.$swal.fire({
                title: 'Erreur',
                text: 'Une erreur s\'est produite. Veuillez vous assurer que tout les champs nécessaires soient remplis.',
                type: 'error'
              });
            }
          }
          finally {
            this.loading = false;
          }
        }
      },
      updateUser(data) {
        this.user = data;
      }
    }
  };
</script>

<style scoped></style>
